import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import Slider from "react-slick";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { dashboardAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import WaitScreen from "../LodingScreen/WaitScreen";
import SeoAdd from "../Seo/SeoAdd";
import SubmitForm from "../SubmitForm/SubmitForm";
import { useTranslation } from "react-i18next";
import { isAws } from "../../constant/utils";

const EcmeDetails = () => {
  const { t } = useTranslation();
  const { slug } = useParams<any>();
  const dispatch = useDispatch();
  const [uri, setUri] = useState<any>({});
  const [cme, setCme] = useState<any>({});
  const cmeData: any = useSelector((state: any) =>
    state.dashboard.cmeDetails ? state.dashboard.cmeDetails : {}
  );

  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(dashboardAction.cmeBySlugAction(slug));
    return () => {};
  }, []);

  useEffect(() => {
    if (cmeData) {
      setUri({
        iBASE: cmeData?.ImageBaseUrl,
        vBASE: cmeData?.ImageBaseUrl,
        iAWS: cmeData?.AwsImageBaseUrl,
        vAWS: cmeData?.AwsVideoBaseUrl,
      });
      setCme(cmeData?.CMEDetails);
    }
    return () => {};
  }, [cmeData]);

  var settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    centerMode: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <SeoAdd slug={ROUTE.ECME + "/" + slug} />
      {cmeData && Object.keys(cmeData)?.length < 1 && <WaitScreen />}
      <BreadCrumb
        page={t("news_update")}
        data={{ slug: slug, path: ROUTE.NEWSANDUPDATES }}
      />
      {cme && Object.keys(cme)?.length > 0 && (
        <>
          <section className="about-section">
            <div className="container" id="section2">
              <div className="row">
                <div className="col-md-12">
                  <div className="text-center">
                    <div className="overview-wrap mb-3">
                      {cme?.Images &&
                        cme?.Images?.length > 0 &&
                        cme?.Images[0]?.image && (
                          <div>
                            <img
                              src={
                                isAws(cme?.Images[0]?.image) ?
                                `${uri?.iAWS}${cme?.Images[0]?.image}` : `${uri?.iBASE}${cme?.Images[0]?.image}` /* : "/assets/img/histopathology.jpg"} onError={(e: any) => ImgPlaceHolder(e, "/assets/img/histopathology.jpg") */
                              }
                              className="scale"
                              alt=""
                            />
                          </div>
                        )}
                      <div className="headingmains text-center pb-3">
                        <h1 className="right aos-init pb-2 mt-3 mt-lg-5">
                          {cme?.EventTitle}
                        </h1>
                      </div>
                      <p
                        className="dull_heading pb-lg-3"
                        dangerouslySetInnerHTML={{ __html: cme?.Details }}
                      ></p>
                    </div>
                    {cme?.CreatedAt && (
                      <div className="headingmains text-center mt-3 mb-n4">
                        <p>
                          {cme?.CreatedAt &&
                            moment(cme?.CreatedAt).format("MMMM DD, YYYY")}{" "}
                          {cme?.PostedBy ? "by " + cme?.PostedBy : ""}
                        </p>
                      </div>
                    )}
                    <div className="dtl dlt01">
                      <div className="dtl_box">
                        <h5 className="mb-2">
                          <img
                            src="/assets/img/ecme_calendar.png"
                            className="scale_booknow"
                            alt=""
                          />
                          <span>{t("date_name")}</span>
                        </h5>
                        <p>
                          {cme?.date &&
                            moment(cme?.date).format("DD, MMMM YYYY")}
                        </p>
                      </div>
                      <div className="dtl_box">
                        <h5 className="mb-2">
                          <img
                            src="/assets/img/ecme_clock.png"
                            className="scale_booknow"
                            alt=""
                          />
                          <span>{t("time")}</span>
                        </h5>
                        <p>
                          {cme?.Time && moment(cme?.Time, "hh:mm").format("LT")}
                        </p>
                      </div>
                      <div className="dtl_box">
                        <h5 className="mb-2">
                          <img
                            src="/assets/img/ecme_venue.png"
                            className="scale_booknow"
                            alt=""
                          />
                          <span>{t("venue")}</span>
                        </h5>
                        <p className="location">{t(cme?.Location)}</p>
                      </div>
                    </div>
                    {/* <div className='ecme_box_wrap'>
                                    <div className='ecme_box'>
                                        <h5 className='mb-2'>Total Attendees</h5>
                                        <p>Hematopathology (including lymph node pathology)</p>
                                        <p> Oncopathology</p>
                                        <p> Multicolor Flow cytometry</p>
                                        <p> Molecular Oncopathology</p>
                                    </div>
                                    <div className='ecme_box'>
                                        <h5 className='mb-2'>Discussed Point</h5>
                                        <ul>
                                            <li>Hematopathology (including lymph node pathology)</li>
                                            <li> Oncopathology</li>
                                            <li> Multicolor Flow cytometry</li>
                                            <li> Molecular Oncopathology</li>
                                        </ul>
                                    </div>
                                </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="nrlDiv">
            <section className="section">
              <div id="section2">
                <div className="row">
                  <div className="col-md-12">
                    <div className="overview-wrap">
                      <div className="headingmains text-center pb-3">
                        <h2 className="right aos-init pb-2 mt-sm-4 text-white p-2">
                          {t("health_talk_expert")}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="nrl_slider nrl_sli1">
                  <Slider {...settings}>
                    <div>
                      <img className="scale" src="/assets/img/1.jpg" alt="" />
                    </div>
                    <div>
                      <img className="scale" src="/assets/img/2.jpg" alt="" />
                    </div>
                    <div>
                      <img className="scale" src="/assets/img/3.jpg" alt="" />
                    </div>
                    <div>
                      <img className="scale" src="/assets/img/4.jpg" alt="" />
                    </div>
                    {/* <div>
                                <img className="scale" src="/assets/img/nrl_usp.jpg" alt="" />
                            </div>
                            <div>
                                <img className="scale" src="/assets/img/nrl_usp.jpg" alt="" />
                            </div>
                            <div>
                                <img className="scale" src="/assets/img/nrl_usp.jpg" alt="" />
                            </div>
                            <div>
                                <img className="scale" src="/assets/img/nrl_usp.jpg" alt="" />
                            </div> */}
                  </Slider>
                </div>
              </div>
            </section>
          </div>
          <SubmitForm
            heading={t("reach_out-to_us")}
            des={""}
            PageSrc={"EcmeDetails"}
          />
        </>
      )}
    </>
  );
};

export default EcmeDetails;
